import { render, staticRenderFns } from "./Sections.vue.js?vue&type=template&id=136633c8!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sections.vue?vue&type=template&id=136633c8"
import script from "./Sections.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sections.vue?vue&type=script&lang=js"
export * from "./Sections.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136633c8')) {
      api.createRecord('136633c8', component.options)
    } else {
      api.reload('136633c8', component.options)
    }
    module.hot.accept("./Sections.vue.js?vue&type=template&id=136633c8!=!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@3.6.0_webpack@5.112.0__handlebars@4.7.10_lodash@4.18.1_vu_6aaa316a0b49f59667a617df5dc64b72/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sections.vue?vue&type=template&id=136633c8", function () {
      api.rerender('136633c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/components/routes/sections/Sections.vue"
export default component.exports